import React from 'react'
import {ILeaderDetail} from '../../../../apis/leader/getLeaderDetail'
import WizImage from '../../../../components/image/WizImage'
import {useImage} from '../../../../utils/image'
import Text from '../../../../components/text/Text'
import useQueryExchanges from '../../../../hooks/etc/useQueryExchanges'
import WizButton from '../../../../components/button/WizButton'
import useNavigation from '../../../../hooks/useNavigation'
import {useTime} from '../../../../utils/time'
import {useTag} from '../../../../utils/etc'

interface IProps {
    className?: string
    leaderDetail?: ILeaderDetail
}

const LeaderUserContainer: React.FC<IProps> = ({className, leaderDetail}) => {
    const {renderThumbnail} = useImage()
    const {goUserDetail} = useNavigation()
    const {localTimeString} = useTime()
    const {renderStateColor} = useTag()
    const {data: exchanges} = useQueryExchanges()

    return (
        <div
            className={`p-[20px] bg-white rounded-[10px] shadow-normal flex space-x-[10px]  items-center md:flex-col md:space-x-0 md:text-center md:relative ${className} `}>
            <div>
                <WizImage
                    src={renderThumbnail(leaderDetail?.user_thumbnail)}
                    className={'w-[60px] h-[60px] rounded-full'}
                />
            </div>
            <div className={'flex-1'}>
                <div className={'flex items-center space-x-[7px] md:pb-[10px] md:justify-center'}>
                    <Text className={'text-h3'}>{leaderDetail?.copy_lead_name}</Text>
                    <WizImage
                        src={exchanges?.find(exchange => exchange.name === leaderDetail?.exchange)?.icon}
                        className={'w-[20px]'}
                    />
                    <Text className={`${renderStateColor(leaderDetail?.allow_copy)}`}>
                        {leaderDetail?.allow_copy ? 'Copy Allowed' : 'Copy Blocked'}
                    </Text>
                </div>
                <Text className={'text-body3 text-font03'}>User Name : {leaderDetail?.user_name}</Text>
                <Text className={'text-body3 text-font03'}>
                    Create At : {leaderDetail?.created_at ? localTimeString(leaderDetail?.created_at) : '-'}
                </Text>
            </div>
            <div className={'flex space-x-[10px] md:pt-[10px]'}>
                <WizButton
                    text={'Leaderfolio'}
                    type={'leader'}
                    onClick={() => window.open(`https://leagueoftraders.io/ko/key/${leaderDetail?.id}/portfolio`)}
                />
                <WizButton text={'User Detail'} type={'blue'} onClick={() => goUserDetail(leaderDetail?.user_id)} />
            </div>
        </div>
    )
}

export default LeaderUserContainer
